/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GeocodingAddress } from '../../models/geocoding-address';

export interface ReverseSearch$Params {
  lat: number;
  lon: number;
  geocoder?: string;
}

export function reverseSearch(http: HttpClient, rootUrl: string, params: ReverseSearch$Params, context?: HttpContext): Observable<StrictHttpResponse<GeocodingAddress>> {
  const rb = new RequestBuilder(rootUrl, reverseSearch.PATH, 'get');
  if (params) {
    rb.query('lat', params.lat, {"style":"form","explode":true});
    rb.query('lon', params.lon, {"style":"form","explode":true});
    rb.query('geocoder', params.geocoder, {"style":"form","explode":true});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GeocodingAddress>;
    })
  );
}

reverseSearch.PATH = '/api/v1/geocoding/addresses/reverse_search';
